<template>
  <div class="main-layout">
    <MainHeader />

    <!-- Indikator perpindahan halaman: garis tipis di bawah header.
         Versi lama menutup seluruh layar dengan overlay hitam pekat selama
         satu detik penuh lewat setTimeout, terlepas dari apakah halaman sudah
         siap atau belum. Sekarang indikator hanya muncul saat navigasi
         benar-benar berlangsung. -->
    <div v-if="isNavigating" class="route-progress" role="status" aria-live="polite">
      <span class="visually-hidden">{{ $t('common.loading') }}</span>
    </div>

    <main id="main-content" class="main-layout__content">
      <PenangkapGalat>
        <router-view v-slot="{ Component }">
          <component :is="Component" :key="$route.fullPath" />
        </router-view>
      </PenangkapGalat>
    </main>

    <MainFooter />
  </div>
</template>

<script>
import MainHeader from '@/components/main/MainHeader.vue';
import MainFooter from '@/components/main/MainFooter.vue';
import PenangkapGalat from '@/components/admin/PenangkapGalat.vue';

export default {
  name: 'MainLayout',

  components: { MainHeader, MainFooter, PenangkapGalat },

  data() {
    return {
      isNavigating: false,
    };
  },

  created() {
    /*
     * Versi lama memanggil useRouter() di dalam mounted() pada Options API —
     * di luar setup(), fungsi itu mengembalikan undefined, sehingga pemasangan
     * hook navigasinya tidak pernah benar-benar bekerja. Di sini dipakai
     * this.$router yang selalu tersedia, dan hook-nya dilepas saat komponen
     * dibongkar supaya tidak menumpuk.
     */
    this.removeBeforeEach = this.$router.beforeEach((to, from, next) => {
      this.isNavigating = true;
      next();
    });

    this.removeAfterEach = this.$router.afterEach(() => {
      this.isNavigating = false;
    });
  },

  beforeUnmount() {
    if (this.removeBeforeEach) this.removeBeforeEach();
    if (this.removeAfterEach) this.removeAfterEach();
  },
};
</script>

<style scoped>
.main-layout {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background-color: var(--bg-base);
}

.main-layout__content {
  flex: 1;
  /* Offset setinggi header — menggantikan padding-top: 200px di global.css */
  padding-top: var(--header-height);
}

.route-progress {
  position: fixed;
  top: var(--header-height);
  left: 0;
  right: 0;
  height: 3px;
  z-index: var(--z-header);
  overflow: hidden;
  background-color: var(--bg-sunken);
}

.route-progress::after {
  content: '';
  position: absolute;
  inset-block: 0;
  width: 40%;
  background-color: var(--accent);
  animation: route-progress 1s ease-in-out infinite;
}

@keyframes route-progress {
  0%   { transform: translateX(-100%); }
  100% { transform: translateX(350%); }
}

.page-enter-active,
.page-leave-active {
  transition: opacity var(--transition-base);
}

.page-enter-from,
.page-leave-to {
  opacity: 0;
}
</style>
